const magic = {
  ZCLITE_TRACKING_TAG_AUTOCHECK_INTERVAL: 10000,
  ZCLITE_CONVERSION_TAG_AUTOCHECK_INTERVAL: 10000
};

export default magic;



// WEBPACK FOOTER //
// ./src/libs/magic_numbers.js